import React, { useEffect, useState } from 'react';
import _ from 'lodash';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import Checkbox from 'material-ui/Checkbox';
import AwaitableBtn from 'components/Base/AwaitableBtn';
import Toggle from 'material-ui/Toggle';
import { TextField } from 'material-ui';

/**
 * 
 * @param {{ 
 *  selectedBrokerMails: string[], selectedListeners: Listener[], handleFilterBroker: Function,
 *  handleClose: Function, brokerMails: string[], showUniqueBrokerMails: boolean,
 *  handleToggleShowUniqueBrokerMails: (e: MouseEvent, isInputChecked: boolean) => void, 
 * listeners: Listener[],
 * }} param0 
 */

export default function BrokerMailsModal({ 
    selectedBrokerMails, selectedListeners, handleFilterBroker, handleClose,
    brokerMails, showUniqueBrokerMails, handleToggleShowUniqueBrokerMails, listeners,
}) {
    const [brokerMailsArr, setBrokerMailsArr] = useState(selectedBrokerMails || []);
    const [currentListeners, setCurrentListeners] = useState(selectedListeners || []);
    const [allListeners, setAllListeners] = useState(listeners);
    const [allBrokerMails, setAllBrokerMails] = useState(brokerMails);
    const [filterString, setFilterString] = useState('');

    useEffect(() => {
        if (!filterString) {
            setAllBrokerMails(brokerMails);
            setAllListeners(listeners);
        } else {
            setAllBrokerMails(brokerMails.filter(b => new RegExp(filterString, 'i').test(b)));
            setAllListeners(listeners.filter(l => new RegExp(filterString, 'i').test(l.company.name)));
        }
    }, [filterString]);
    

    const handleCheck = (value) => {
        if (typeof value === 'string') {
            const idIndex = _.indexOf(brokerMailsArr, value);
            
            if (idIndex < 0) {
                setBrokerMailsArr(_.uniq([...brokerMailsArr, value]));
            } else {
                setBrokerMailsArr(brokerMailsArr.filter((_item, index) => index !== idIndex));
            }
        } else {
            const idIndex = currentListeners.findIndex(item => item.company._id === value.company._id);
            
            if (idIndex < 0) {
                setCurrentListeners(_.uniq([...currentListeners, value]));
            } else {
                setCurrentListeners(currentListeners.filter((_item, index) => index !== idIndex));
            }
        }
    };

    const handleFilter = async () => {
        await handleFilterBroker(brokerMailsArr, currentListeners);
    };

    const actions = [
        <div
            style={{ display: 'flex', justifyContent: 'flex-end' }}
        >
            <div style={{ width: '40%' }}>
                <Toggle 
                    name="toggl"
                    title={!brokerMailsArr.length ? 'Select broker mail' : ''}
                    label="Unique broker mails"
                    labelPosition="right"
                    style={{ padding: '8px 0 0 20px' }}
                    labelStyle={{ display: 'flex' }}
                    toggled={showUniqueBrokerMails}
                    onToggle={handleToggleShowUniqueBrokerMails}
                    disabled={!brokerMailsArr.length}
                />
            </div>
            <div style={{ width: '60%' }}>
                <FlatButton
                    label="Cancel"
                    primary
                    onClick={() => {
                        handleClose();
                    }}
                />
                <AwaitableBtn>
                    <FlatButton
                        label="Filter"
                        primary
                        onClick={handleFilter}
                    />
                </AwaitableBtn>
            </div>
        </div>,
    ];

    return (
        <Dialog
            title="Select broker mails"
            actions={actions}
            modal={false}
            open
            onRequestClose={() => {
                handleClose();
            }}
            autoScrollBodyContent
        >
            <TextField 
                hintText='Search broker email'
                value={filterString}
                onChange={e => setFilterString(e.target.value)}
            />
            <div
                style={{ minHeight: '90vh' }}
            >
                {
                    allBrokerMails && allBrokerMails.map(item => (<Checkbox 
                        checked={brokerMailsArr.includes(item)}
                        key={item}
                        value={item}
                        label={item}
                        style={{ marginTop: 16 }}
                        onCheck={() => handleCheck(item)}
                    />))
                }
                {
                    allListeners && allListeners.map(item => (<Checkbox 
                        checked={currentListeners && !!currentListeners.find(stl => stl.company._id === item.company._id)}
                        key={item.company._id}
                        label={`[ ${item.parser} ] ${item.company.name}`}
                        style={{ marginTop: 16 }}
                        onCheck={() => handleCheck(item)}
                    />))
                }
            </div>
        </Dialog>
    );
}

/**
 * @typedef {Object} Listener
 * @property {string} parser 
 * @property {Company} company
 */

/**
 * @typedef {Object} Company
 * @property {string} _id
 * @property {string} name
 */



// WEBPACK FOOTER //
// ./app/components/Letters/List/BrokerMailsModal.jsx